import FileSelect from './FileSelect';

export default FileSelect;
